/* eslint-disable react/prop-types */
import React from 'react';

import {connect} from 'react-redux';

import InputField from '@/components/inputfield/InputField';
import {UpdateStateEnum} from '@/constants/dataEnum';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';

import '../status/AutoProfileStatus.less';

@connect((store) => {
  const {
    currentVolume,
    estimateConcentration,
    currentBuffer,
    profileRunning,
    currentAdvSetupParams,
    concentrationFlowRate,
    currentPCState,
    prevPCState,
    requireRefill,
    autoProfileSetupMode,
  } = store.setupStore;

  return {
    currentVolume,
    estimateConcentration,
    currentBuffer,
    finalVolume: profileRunning[APPDATA.KEY.Config][APPDATA.KEY.FinalVolume] || '0',
    manualControlThreshold:
      currentAdvSetupParams[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][
        APPDATA.KEY.ManualControlThreshold
      ] || '0',
    concentrationFlowRate,
    currentPCState,
    prevPCState,
    requireRefill,
    autoProfileSetupMode,
    highVolumeBuffer:
      currentAdvSetupParams[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][
        APPDATA.KEY.HighVolumeBufferFlag
      ] || false,
  };
})
class StatusSensor extends React.PureComponent {
  leftStatusText() {
    const {currentVolume, currentBuffer, finalVolume, autoProfileSetupMode, requireRefill, highVolumeBuffer} =
      this.props;

    switch (autoProfileSetupMode) {
      case APPDATA.FIELD_NAME.CONCENTRATE:
        return [
          {
            label: APPDATA.FIELD_NAME.CURRENT_SAMPLE_VOLUME,
            value: currentVolume || '0',
            unit: APPDATA.UNIT.ml,
            disabled: true,
          },
          {
            label: APPDATA.FIELD_NAME.FINAL_VOLUME,
            value: finalVolume,
            unit: APPDATA.UNIT.ml,
            disabled: true,
          },
        ];
      case APPDATA.FIELD_NAME.CONC_TWO_TUBES:
        return [
          {
            label: APPDATA.FIELD_NAME.SAMPLE_VOLUME_FIRST_TUBE,
            value: currentVolume || '0',
            unit: APPDATA.UNIT.ml,
            disabled: true,
          },
          {
            label: APPDATA.FIELD_NAME.SAMPLE_VOLUME_SECOND_TUBE,
            value: currentBuffer || '0',
            unit: APPDATA.UNIT.ml,
            disabled: true,
          },
          {
            label: APPDATA.FIELD_NAME.FINAL_VOLUME,
            value: finalVolume,
            unit: APPDATA.UNIT.ml,
            disabled: true,
          },
        ];
      case APPDATA.FIELD_NAME.BUFFER_EXCHANGE:
        return [
          {
            label: APPDATA.FIELD_NAME.CURRENT_SAMPLE_VOLUME,
            value: currentVolume || '0',
            unit: APPDATA.UNIT.ml,
            disabled: true,
          },
          {
            label: !highVolumeBuffer ? APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME : APPDATA.FIELD_NAME.EST_CURRENT_BUFFER,
            value: currentBuffer || '0',
            unit: APPDATA.UNIT.ml,
            disabled: true,
          },
          {
            label: APPDATA.FIELD_NAME.FINAL_VOLUME,
            value: finalVolume,
            unit: APPDATA.UNIT.ml,
            disabled: true,
          },
          {
            label: APPDATA.FIELD_NAME.REQUIRES_REFILL,
            value: +parseFloat(requireRefill).toFixed(2) || '0',
            unit: APPDATA.UNIT.ml,
            disabled: true,
          },
        ];
      default:
        break;
    }

    return [
      {
        label: APPDATA.FIELD_NAME.CURRENT_SAMPLE_VOLUME,
        value: currentVolume || '0',
        unit: APPDATA.UNIT.ml,
        disabled: true,
      },
      {
        label: APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME,
        value: currentBuffer || '0',
        unit: APPDATA.UNIT.ml,
        disabled: true,
      },
      {
        label: APPDATA.FIELD_NAME.FINAL_VOLUME,
        value: finalVolume,
        unit: APPDATA.UNIT.ml,
        disabled: true,
      },
    ];
  }

  rightStatusText() {
    const {finalVolume, manualControlThreshold, estimateConcentration, currentPCState, concentrationFlowRate} =
      this.props;

    let statusRight = [
      {
        label: APPDATA.FIELD_NAME.EST_CONCENTRATION_RATE,
        value: currentPCState === UpdateStateEnum.CONCENTRATING ? concentrationFlowRate : 0,
        unit: APPDATA.UNIT.mL_per_min,
        disabled: true,
      },
      {
        label: APPDATA.FIELD_NAME.EST_CURRENT_CONCENTRATION,
        value: estimateConcentration || '0',
        unit: APPDATA.UNIT.mg_per_ml,
        disabled: true,
      },
    ];

    if (finalVolume < 3) {
      statusRight = [
        ...statusRight,
        {
          label: APPDATA.FIELD_NAME.MANUAL_CONTROL_THRESHOLD,
          value: manualControlThreshold,
          unit: APPDATA.UNIT.ml,
          disabled: true,
        },
      ];
    }

    return statusRight;
  }

  render() {
    const statusTextLeft = this.leftStatusText();
    const statusTextRight = this.rightStatusText();

    const generateStatusText = (statusText) => {
      let key = -1;
      const status = statusText.map((status) => {
        key += 1;
        return (
          <div
            key={key}
            className={`${APPSTYLE.COLUMN_FULL}no-padding properties-coloumn status-text`}
          >
            <InputField
              labelClassname={`no-padding status-text-field ${APPSTYLE.COLUMN_6}`}
              label={status.label}
              inputValue={status.value}
              unit={status.unit}
              onClick={undefined}
              disabled={status.disabled}
              inputClassName={APPSTYLE.COLUMN_4}
              unitClassName={APPSTYLE.COLUMN_2}
            />
          </div>
        );
      });
      return status;
    };

    return (
      <>
        <div className={`${APPSTYLE.COLUMN_6}statusText no-padding`}>{generateStatusText(statusTextLeft)}</div>
        <div className={`${APPSTYLE.COLUMN_6}statusText no-padding`}>{generateStatusText(statusTextRight)}</div>
      </>
    );
  }
}
export default StatusSensor;
